export const LedgerTrans_trnsData_originId = `trnsData.originId`;